import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import '../assets/css/CaseStudiesDetails.css';
import { API_BASE_URL, UPLOADS_BASE_URL } from '../config';

const CaseStudiesDetails = () => {
  const { id } = useParams();
  const [caseStudy, setCaseStudy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    const fetchCaseStudyDetails = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}case_studies.php?id=${id}`);
        
        // First check if the response is ok
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        // Try to parse the response as JSON
        const text = await res.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          console.error('Failed to parse JSON:', text);
          throw new Error('Invalid JSON response from server');
        }

        // Check if the response has the expected structure
        if (!data || typeof data !== 'object') {
          throw new Error('Invalid response format');
        }

        if (data.success && data.data.length > 0) {
          const studyData = data.data[0];
          // Ensure images is an array
          studyData.images = Array.isArray(studyData.images) ? studyData.images : [];
          setCaseStudy(studyData);
        } else {
          throw new Error(data.error || 'Case study not found');
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setError(`Error: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchCaseStudyDetails();
  }, [id]);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  if (loading) {
    return (
      <div className="loading"></div>
    );
  }

  if (error) {
    return (
      <div className="case-studies-details-wrapper">
        <div className="error">{error}</div>
      </div>
    );
  }

  if (!caseStudy) {
    return (
      <div className="case-studies-details-wrapper">
        <div className="error">Case study not found</div>
      </div>
    );
  }

  const slides = caseStudy.images.map(image => ({
    src: `${UPLOADS_BASE_URL}case-studies/${image}`,
    alt: `${caseStudy.name} Project Image`
  }));

  const heroImage = caseStudy.images[0];
  const galleryImages = caseStudy.images.slice(1) || [];

  return (
    <div className="case-studies-details-wrapper">
      {/* <div className="breadcrumb-container">
        <div className="container">
          <div className="breadcrumb-wrapper">
            <Link to="/" className="breadcrumb-link">Home</Link>
            <FaChevronRight className="breadcrumb-separator" />
            <Link to="/case-study" className="breadcrumb-link">Case Studies</Link>
            <FaChevronRight className="breadcrumb-separator" />
            <span className="breadcrumb-current">{caseStudy?.name}</span>
          </div>
        </div>
      </div> */}
      
      <div className="case-study-details">
        <div className="hero-section">
          {heroImage && (
            <div className="hero-image">
              <img
                src={`${UPLOADS_BASE_URL}case-studies/${heroImage}`}
                alt={`${caseStudy.name} Hero`}
                onError={(e) => {
                  console.error('Hero image failed to load:', e.target.src);
                  e.target.src = require('../assets/images/products/desks/1.png');
                }}
              />
              <div className="hero-overlay">
                <div className="hero-content">
                  <h1 className="hero-title">{caseStudy.name}</h1>
                  <p className="hero-subtitle">{caseStudy.type}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="container">
          <div className="case-study-content">
            <div className="main-content">
              {/* Dynamic content from backend - renders HTML elements like h1, p, ul, etc. */}
              <div 
                className="project-description"
                dangerouslySetInnerHTML={{ __html: caseStudy.description }}
              />
            </div>

            <div className="project-info">
              <div className="info-title">PROJECT INFO</div>
              
              <div className="info-section">
                <div className="info-label">AREA:</div>
                <div className="info-value">{caseStudy.sqft} sq ft</div>
              </div>

              <div className="info-section">
                <div className="info-label">LOCATION:</div>
                <div className="info-value">{caseStudy.location}</div>
              </div>

              <div className="info-section">
                <div className="info-label">TIMESCALE:</div>
                <div className="info-value">{caseStudy.timescale}</div>
              </div>

              <div className="info-section">
                <div className="info-label">PROJECT SCOPE:</div>
                <div className="info-value">{caseStudy.scope}</div>
              </div>
            </div>
          </div>

          <div className="gallery-section">
            <h2 className="gallery-title">PROJECT GALLERY</h2>
            <div className="gallery-grid">
              {galleryImages.length > 0 ? (
                galleryImages.map((image, index) => (
                  <div 
                    key={index} 
                    className="gallery-item"
                    onClick={() => openLightbox(index + 1)}
                  >
                    <img
                      src={`${UPLOADS_BASE_URL}case-studies/${image}`}
                      alt={`${caseStudy.name} Project Image`}
                    />
                  </div>
                ))
              ) : (
                <div>No images available</div>
              )}
            </div>
          </div>
        </div>
      </div>

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          slides={slides}
          index={photoIndex}
        />
      )}
    </div>
  );
};

export default CaseStudiesDetails;